/**
 * Ferme le drawer mobile Dawn au clic sur un lien one-page Mindset (ancre
 * #mindset-*), en appelant la méthode native closeMenuDrawer() de la classe
 * HeaderDrawer (voir assets/global.js) — aucune logique recréée : overlay,
 * verrouillage du scroll du body (overflow-hidden-*) et gestion du focus
 * restent entièrement gérés par Dawn lui-même.
 *
 * closeMenuDrawer() ne retire l'attribut `open` du <details> qu'après un
 * délai de 400ms géré par MenuDrawer.closeAnimation() (requestAnimationFrame
 * dans global.js) — c'est ce délai, et non une classe, qui contrôle la
 * disparition du voile semi-transparent (#menu-drawer > details[open] >
 * summary::before, voir component-menu-drawer.css). Si on laisse le
 * navigateur naviguer vers l'ancre immédiatement (comportement par défaut du
 * clic), le scroll de la page et l'animation de fermeture tournent en même
 * temps ; sur certains mobiles (Safari iOS notamment) cela peut empêcher le
 * délai de 400ms de s'exécuter proprement et laisser le voile affiché. On
 * empêche donc la navigation par défaut, on lance la fermeture native, puis
 * on ne navigue vers l'ancre qu'une fois ce même délai de 400ms écoulé —
 * repris tel quel de MenuDrawer.closeAnimation(), pas une valeur inventée.
 */
document.addEventListener('DOMContentLoaded', function () {
  var headerDrawer = document.querySelector('header-drawer');
  if (!headerDrawer) return;

  var summary = headerDrawer.querySelector('.header__icon--menu');
  var onepageLinks = headerDrawer.querySelectorAll('a[href*="#mindset-"]');

  onepageLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var targetHash = link.hash;

      event.preventDefault();
      headerDrawer.closeMenuDrawer(event, summary);

      window.setTimeout(function () {
        if (targetHash) {
          window.location.hash = targetHash;
        }
      }, 400);
    });
  });
});
